import { Color, Entity, } from "cesium";
import { useEffect, useRef } from "react";
import { useCesium } from "../Contexts/Widget3DContext";
export const Ellipsoid = ({ name, position, availability, color = Color.CRIMSON, radii, orientation, }) => {
    const ellipsoidEntity = useRef(null);
    const { isViewerLoaded, addEntity, removeEntity } = useCesium();
    const addEllipsoid = () => {
        const newEllipsoidEntity = new Entity({
            id: `Ellipsoid ${name}`,
            position,
            availability: availability ? availability : null,
            orientation: orientation,
            ellipsoid: {
                radii: radii,
                fill: false,
                outline: true,
                outlineColor: color,
                slicePartitions: 24,
                stackPartitions: 36,
            },
        });
        return addEntity(newEllipsoidEntity);
    };
    useEffect(() => {
        if (isViewerLoaded) {
            (ellipsoidEntity === null || ellipsoidEntity === void 0 ? void 0 : ellipsoidEntity.current) && removeEntity(ellipsoidEntity.current);
            ellipsoidEntity.current = addEllipsoid();
        }
        return () => {
            (ellipsoidEntity === null || ellipsoidEntity === void 0 ? void 0 : ellipsoidEntity.current) && removeEntity(ellipsoidEntity.current);
        };
    }, [position, availability, color, radii, orientation, isViewerLoaded]);
    return null;
};
//# sourceMappingURL=Ellipsoid.js.map